import { cardLabel, suitLabel } from './cards.js';
import type { IllegalReason } from './legal-moves.js';

/**
 * The one-line reason shown when a player taps a greyed-out card. Lives in core
 * so the toast the client shows and the error the server returns are the same
 * sentence.
 */
export function explainReason(reason: IllegalReason): string {
  switch (reason.code) {
    case 'must-follow-suit':
      return `Je hebt nog ${suitLabel(reason.suit)} — je moet volgen.`;
    case 'must-overtake':
      return `Je moet over de ${cardLabel(reason.master)} met een hogere ${suitLabel(reason.suit)}.`;
    case 'must-trump':
      return `Geen ${suitLabel(reason.led)} meer — je moet troeven met ${suitLabel(reason.trump)}.`;
    case 'must-overtrump':
      return `Je moet de ${cardLabel(reason.master)} overtroeven.`;
    case 'must-trump-losing':
      return `Je raakt niet over de ${cardLabel(reason.master)} — maar je moet toch een troef bijgooien.`;
    case 'not-in-hand':
      return 'Die kaart zit niet in je hand.';
    case 'not-your-turn':
      return 'Niet jouw beurt.';
    case 'not-playing':
      return 'Er is geen slag bezig.';
  }
}
